import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const Products = ({ name = "" }) => {
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the list of products from the server
  const loadProducts = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "product" });
    // const response = await getCampaigns({ token, type: "product" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((product: any) => {
          return {
            id: product.id,
            label: product.name,
            caption: `Last Updated: ${moment(product.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setProductList(seqs);
    }
    setIsLoading(false);
  };

  // load the productList when the page loads
  useEffect(() => {
    loadProducts();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/launchpad/products" className="justify-end">
            <Button label="+ Create a Product" type={ButtonTypes.OUTLINED} />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(productList.length) && (
          <EmptyState
            title="No Products Yet"
            description="Get started by creating a new product."
            showImage={false}
          >
            <Link to="/launchpad/products">
              <Button label="Create a Product" type={ButtonTypes.DEFAULT} />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(productList.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {productList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/products/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
